/**
 * Created by mac85103 on 11/3/16.
 */
import { Directive, ElementRef, HostListener, Inject } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
    selector: '[stopccp]'
})
export class StopCCPDirective {

    constructor(@Inject(NgControl) private control: NgControl,
                @Inject(ElementRef) private $el: ElementRef) {}

    @HostListener('cut', ['$event']) onCutChange(event?) {
        event.preventDefault();
    }

    @HostListener('copy', ['$event']) onCopyChange(event?) {
        event.preventDefault();
    }

    @HostListener('paste', ['$event']) onPasteChange(event?) {
        event.preventDefault();
    }

}
